import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import LineItem from './LineItem'
import animations from '../../animations.module.scss'
import { CartLineItem as LineItemType } from 'types/checkout'
import { GenericFunction } from 'types/helpers'
import { Layout } from './CartItem'
import SuitLineItem from './SuitLineItem'
import {
  getBundledItems,
  getBundleId,
  getBundleRole,
  getLineItemProperties
} from '@helpers/cart/bundle'

type CartProductsListProps = {
  updateCartQuantity: GenericFunction
  setShowSuitDeletedNotification: GenericFunction
  lineItems: LineItemType[]
  layout: Layout
}

function CartProductsList({
  updateCartQuantity,
  setShowSuitDeletedNotification,
  lineItems = [],
  children = null,
  layout = 'small'
}: React.PropsWithChildren<CartProductsListProps>) {
  const suitItems = getBundledItems(lineItems)

  const visitedBundleIds: string[] = []

  return (
    <TransitionGroup className={animations.basket__items}>
      {lineItems.map(item => {
        const bundleId = getBundleId(item)

        if (bundleId) {
          if (visitedBundleIds.includes(bundleId)) {
            return <></>
          }

          visitedBundleIds.push(bundleId)

          const bundleItems = suitItems[bundleId]
          if (!bundleItems || bundleItems.length < 2) return null

          const primaryProduct =
            bundleItems.find(item => getBundleRole(item) === 'primary') ||
            bundleItems[0]

          const secondaryProduct =
            bundleItems.find(item => getBundleRole(item) === 'secondary') ||
            bundleItems[1]

          if (!primaryProduct || !secondaryProduct) return null

          return (
            <CSSTransition
              key={item.id}
              timeout={300}
              classNames="transition__item"
            >
              <SuitLineItem
                primaryProduct={{
                  ...getLineItemProperties(primaryProduct),
                  updateQuantity: (id, qty) =>
                    updateCartQuantity(id, primaryProduct.merchandise.id, qty),
                  setShowSuitDeletedNotification:
                    setShowSuitDeletedNotification,

                  layout: layout
                }}
                secondaryProduct={{
                  ...getLineItemProperties(secondaryProduct),
                  updateQuantity: (id, qty) =>
                    updateCartQuantity(
                      id,
                      secondaryProduct.merchandise.id,
                      qty
                    ),
                  layout: layout
                }}
              />
            </CSSTransition>
          )
        }

        return (
          <CSSTransition
            key={item.id}
            timeout={300}
            classNames="transition__item"
          >
            <LineItem
              {...getLineItemProperties(item)}
              updateQuantity={(id, qty) =>
                updateCartQuantity(id, item.merchandise.id, qty)
              }
              layout={layout}
            />
          </CSSTransition>
        )
      })}
      {children}
    </TransitionGroup>
  )
}

export default CartProductsList
